import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {Modal, Input, Select} from 'antd'

import style from './modal.sass'

@observer
class ModalWrapper extends Component {
  handleOk = () => {
    const {indicator, handleOk} = this.props
    indicator.commitChanges()
    handleOk()
  }
  handleCancel = () => {
    const {indicator, handleCancel} = this.props
    indicator.discardChanges()
    handleCancel()
  }
  render() {
    const {visible, indicator} = this.props
    if (!indicator) {
      return null
    }
    const {options, paramsToChange: params, changeParam} = this.props.indicator
    return(
      <Modal
        title={indicator.name}
        visible={visible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
      >
        {options.map(option => {
          if (option.ident === 'TICKER' || option.ident === 'BOLLINGER_TYPE') {
            return
          }
          const selectChange = (value) => changeParam(option.ident, value)
          const numberChange = (e) => changeParam(option.ident, +e.target.value)
          return(
            <div
              key={option.ident}
              styleName='wrapper'
            >
              <label>{option.name}</label>
              {Array.isArray(option.options) ?
                <Select
                  style={{width:90}}
                  value={params[option.ident]}
                  placeholder={option.default_value}
                  onChange={selectChange}
                  dropdownMatchSelectWidth={false}
                  size='small'
                >
                  {option.options.map(val =>
                    <Select.Option
                      key={val}
                      value={val}
                    >
                      {val}
                    </Select.Option>
                  )}
                </Select>
                :
                <Input
                  value={params[option.ident]}
                  placeholder={option.default_value}
                  onChange={numberChange}
                  size='small'
                  style={{width:90}}
                />
              }
            </div>
          )
        })}
      </Modal>
    )
  }
}

export default ModalWrapper
